
import './index.css';

const LandingPageComponent = () => {

    return (
        <div id='landing-page-container'>
            <div id='landing-page-backdrop-glow'></div>

            <section id='landing-page-content'>
                <div id='landing-page-sigil' aria-hidden='true'>
                    <div className='landing-page-ring landing-page-ring-outer'></div>
                    <div className='landing-page-ring landing-page-ring-middle'></div>
                    <div className='landing-page-ring landing-page-ring-inner'></div>
                    <div id='landing-page-core'>A</div>
                    <span className='landing-page-star landing-page-star-top'></span>
                    <span className='landing-page-star landing-page-star-right'></span>
                    <span className='landing-page-star landing-page-star-bottom'></span>
                    <span className='landing-page-star landing-page-star-left'></span>
                </div>

                <div id='landing-page-copy'>
                    <p id='landing-page-kicker'>Ameria is waking up</p>
                    <h1 id='landing-page-header'>Preparing a bright new world beyond the gate</h1>
                    <p id='landing-page-subheader'>
                        Characters, inventory, and realm data are fluttering into place now.
                        You will be moved into the site as soon as the world is ready for you.
                    </p>

                    <div id='landing-page-progress-shell' aria-hidden='true'>
                        <div id='landing-page-progress-bar'></div>
                    </div>

                    <div id='landing-page-status-row'>
                        <span className='landing-page-status-dot'></span>
                        <span id='landing-page-status-text'>Finding elite pvpers</span>
                        <span className='landing-page-status-dot'></span>
                        <span id='landing-page-status-text'>Posting bounties</span>
                        <span className='landing-page-status-dot'></span>
                        <span id='landing-page-status-text'>Launching community</span>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default LandingPageComponent;